var _g, _g2, _circle, _circle2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_312_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1572 63.0063V57.0274L37.186 48.8441C40.0044 46.2875 42.2289 44.1435 43.8595 42.4122C45.5102 40.6608 46.6778 39.1107 47.3623 37.7619C48.0669 36.4132 48.4192 35.0543 48.4192 33.6854C48.4192 31.6723 47.7448 30.1121 46.396 29.0049C45.0472 27.8977 43.1448 27.3441 40.6888 27.3441C38.8368 27.3441 37.0552 27.6964 35.344 28.401C33.653 29.0854 32.1633 30.1021 30.8749 31.4508L27.7647 24.9888C29.6167 23.3179 31.7405 22.0395 34.1361 21.1538C36.5519 20.268 39.028 19.8251 41.5645 19.8251C44.6245 19.8251 47.2918 20.3586 49.5666 21.4255C51.8415 22.4925 53.5929 23.9923 54.8209 25.9249C56.069 27.8373 56.6931 30.0719 56.6931 32.6285C56.6931 34.3799 56.3508 36.1011 55.6664 37.7921C54.9819 39.463 53.764 41.3453 52.0126 43.4389C50.2813 45.5325 47.8354 48.0691 44.6748 51.0485L39.7527 55.6384H57.8103V63.0063H28.1572Z",
    fill: "black",
    fillOpacity: 0.45
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_312_501)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_312_501)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 40.5,
    stroke: "white",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 86
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.8384,
    r: 42.5,
    fill: "#84C5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8636 60.2471V54.8021L38.0861 47.3496C40.6527 45.0212 42.6786 43.0687 44.1636 41.4921C45.6669 39.8971 46.7302 38.4854 47.3536 37.2571C47.9952 36.0287 48.3161 34.7912 48.3161 33.5446C48.3161 31.7112 47.7019 30.2904 46.4736 29.2821C45.2452 28.2737 43.5127 27.7696 41.2761 27.7696C39.5894 27.7696 37.9669 28.0904 36.4086 28.7321C34.8686 29.3554 33.5119 30.2812 32.3386 31.5096L29.5061 25.6246C31.1927 24.1029 33.1269 22.9387 35.3086 22.1321C37.5086 21.3254 39.7636 20.9221 42.0736 20.9221C44.8602 20.9221 47.2894 21.4079 49.3611 22.3796C51.4327 23.3512 53.0277 24.7171 54.1461 26.4771C55.2827 28.2187 55.8511 30.2537 55.8511 32.5821C55.8511 34.1771 55.5394 35.7446 54.9161 37.2846C54.2927 38.8062 53.1836 40.5204 51.5886 42.4271C50.0119 44.3337 47.7844 46.6437 44.9061 49.3571L40.4236 53.5371H56.8686V60.2471H29.8636Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_312_501",
    x: 19.8882,
    y: 11.9478,
    width: 45.7997,
    height: 58.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.93869,
    result: "effect1_foregroundBlur_312_501"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_312_501",
    x: 0,
    y: 0,
    width: 87,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_312_501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_501",
    x1: 42.5,
    y1: 0,
    x2: 84.663,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7D7F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.29305d48a0e16e2626f2818c6a4a77f4.svg";
export { ForwardRef as ReactComponent };